import produce from 'immer';

import { SitesAction, SitesState } from './types';

import { AuthAction } from '../auth/types';

type Action = SitesAction | AuthAction;

const initialState: SitesState = {
  list: [],
  idFavoriteSite: 0,
  updating: false,
  loading: false,
  error: false,
};

export default function sites(
  state = initialState,
  action: Action,
): SitesState {
  return produce(state, draft => {
    switch (action.type) {
      case '@sites/SITES_SUCCESS':
        draft.list = action.payload.sites;
        draft.loading = false;
        break;
      case '@sites/LOAD_SITES_REQUEST':
        draft.loading = true;
        break;
      case '@sites/LOAD_SITES_FAILED':
        draft.loading = false;
        break;
      case '@auth/LOGOUT':
        draft = initialState;
        break;
      default:
        return draft;
    }

    return draft;
  });
}
